import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';

/** The signed-in user's decision on analytics cookies (Microsoft Clarity), as stored by the browser. */
export interface IAnalyticsConsentIm {
  /** The app that asked; the panel is "panel". */
  app: string;
  granted: boolean;
}

@Injectable({ providedIn: 'root' })
export class MyAnalyticsConsentService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyAnalyticsConsent`;
  }

  put(analyticsConsentIm: IAnalyticsConsentIm): Observable<void> {
    const headers = this.createHeaders();
    return this.http.put<void>(this.baseUrl, analyticsConsentIm, { headers });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
